export default "__VITE_ASSET__6ab4b06f__"